import { UIText2 } from '@cian/ui-kit';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { InteractiveText } from '@/packages/shared-ui';

import styles from './BackToListingButton.css';

type BackToListingButtonProps = {
  track(): void;
  onClick(): void;
};

export const BackToListingButton: FC<BackToListingButtonProps> = props => {
  const { onClick, track } = props;

  return (
    <InteractiveText
      behaviour="hover_primary_to_primary_hover"
      dataTestId="listing.back-to-listing-button"
      track={track}
      onClick={onClick}
    >
      <span className={styles['text-container']}>
        <IconActionChevronLeft16 color="current_color" />
        <UIText2 color="current_color">Все объявления</UIText2>
      </span>
    </InteractiveText>
  );
};
